import { render, staticRenderFns } from "./consent.vue?vue&type=template&id=4e3535dc&"
import script from "./consent.vue?vue&type=script&lang=js&"
export * from "./consent.vue?vue&type=script&lang=js&"
import style0 from "./consent.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/consent.vue
// module id = 1631
// module chunks = 0